export function createClickableSection(element) {
  const mainLink = element.querySelector('[data-section-main-link]');
  if (!mainLink) return;

  const buttonHidden = mainLink.ariaHidden == 'true';

  const handleSectionClick = () => {
    const isTextSelected = window.getSelection().toString();

    if (!isTextSelected) mainLink.click();
  }

  if (buttonHidden && mainLink) element.addEventListener('click', handleSectionClick);
}
